import { SxProps, Theme } from "@mui/material";
import { Colors } from "../../../constants";

export const dragAndDropIconStyles: SxProps<Theme> = {
	width: '32px',
	height: '32px',
	position: 'absolute',
	top: '-8px',
	left: '-8px',
	color: Colors.white,
	backgroundColor: Colors['2A2A2A'],
	borderRadius: '50%',
	border: `1px solid ${Colors.white_a10}`,
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',

	'& >svg': {
		width: '20px',
		height: '20px',
	},
};
